import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { TrfReportsTable } from '../../../../../../../../../../features/trf/report/trf-reports-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsTrade,
      label: 'TRF Reports',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsTrade>,
  head: () => getPageHead('TRF Reports'),
  component: TrfReportList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsTrade}
    />
  );
}

function TrfReportList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TrfReportsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
